import { render, staticRenderFns } from "./ShippedArticlesMaterials.vue?vue&type=template&id=b00ea1aa&scoped=true"
import script from "./ShippedArticlesMaterials.vue?vue&type=script&lang=js"
export * from "./ShippedArticlesMaterials.vue?vue&type=script&lang=js"
import style0 from "./ShippedArticlesMaterials.vue?vue&type=style&index=0&id=b00ea1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00ea1aa",
  null
  
)

export default component.exports